import * as React from 'react';
import ContentLoader, { List } from 'react-content-loader';

const DotCycler = ({text}) => {
  const [dotIndex, setDotIndex] = React.useState(0);
  const dots = ['.', '..', '...', '....', '.....'];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDotIndex(prevIndex => (prevIndex + 1) % dots.length);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span>{text}{dots[dotIndex]}</span>
  );
};

function Preview({width, height}) {

  return (
    <div className='preloader__preview'>
      <ContentLoader
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        height={height}
        backgroundColor="#f4f4f4"
        foregroundColor="#ecebeb"
      >
        {/* Simulate image block */}
        <rect x="0" y="0" rx="2" ry="2" width={width} height={height} />
      </ContentLoader>
    </div>
  );
}

export function Preloader() {
  const width= 200;
  const height= 288;

  return (
    <div className='preloader'>
      <div className="preloader__message">
        <p><DotCycler text={'Processing the image'}/></p>
      </div>
      <div className='preloader__items'>
        <Preview width={width} height={height}/>
        <Preview width={width} height={height}/>
        <Preview width={width} height={height}/>
      </div>
    </div>
  );
}
